import { RefreshCw } from 'lucide-react';
import { libelleNiveau } from '../../generators/ouverture';
import { texteLisible } from './formatConfig';
import ApercuExercice, { TexteFormules } from './ApercuExercice';
import { ActionsLigne, FOCUS } from './PanierGroupes';

export const SANS_AUTRE_QUESTION = 'Pas d\'autre question pour ce prérequis';

/**
 * Une ligne du tiroir du diagnostic (chantier tiroir-diagnostic, 2026-10-04) :
 * le niveau, le prérequis testé (cliquable, il s'ouvre), la question dessous,
 * puis ↻ Autre question, aperçu et retrait. `prerequis` absent : question
 * ajoutée à la main, marquée « ajoutée ». `onAutre` absent : ↻ grisé.
 */
const LigneDiagnostic = ({ prerequis, payload, nom, onOuvrir, onAutre, onApercu, onRetirer }) => {
  const niveau = prerequis ? libelleNiveau(prerequis.niveau) : '';
  const description = prerequis ? texteLisible(prerequis.description) : '';
  return (
    <div className="flex items-center gap-3 px-4 py-2 text-sm">
      {prerequis ? (
        <span className="w-7 text-center px-1 py-0.5 rounded-md bg-gray-100 text-gray-600 text-[10px] font-semibold flex-shrink-0">{niveau || '?'}</span>
      ) : (
        <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-700 text-[10px] font-semibold flex-shrink-0">ajoutée</span>
      )}
      <span className="flex-1 min-w-0">
        {prerequis && (
          <button type="button" onClick={onOuvrir} aria-label={`ouvrir ${description}`} title={description} className={`block max-w-full text-left text-xs font-semibold text-gray-800 hover:text-blue-700 hover:underline rounded ${FOCUS}`}>
            <TexteFormules className="block truncate">{prerequis.description}</TexteFormules>
          </button>
        )}
        <ApercuExercice payload={payload} className="text-gray-600" />
      </span>
      {prerequis && (
        <button
          type="button"
          // aria-disabled plutôt que disabled : le bouton reste atteignable au clavier,
          // annoncé « désactivé » avec sa raison (title), lisible au survol.
          onClick={onAutre}
          aria-disabled={!onAutre}
          aria-label={`Autre question pour ${description}`}
          title={onAutre ? 'Autre question' : SANS_AUTRE_QUESTION}
          className={`text-blue-500 hover:text-blue-700 aria-disabled:text-gray-300 aria-disabled:cursor-not-allowed rounded flex-shrink-0 ${FOCUS}`}
        >
          <RefreshCw size={13} />
        </button>
      )}
      <ActionsLigne nom={nom} onApercu={onApercu} onRetirer={onRetirer} />
    </div>
  );
};

export default LigneDiagnostic;
